import axios from 'axios'
import store from '@/store'

const BASE_URL = process.env.NODE_ENV === 'production'
  ? process.env.VUE_APP_BASE_URL
  : '//localhost:3003'

axios.interceptors.response.use(
  function (res) {
    if (res.status !== 200) {
      return Promise.reject({ message: res.statusText || res.status })

    }

    const { status, message, data, code } = res.data
    if (status === 'error') {
      return Promise.reject({ code, message })
    }

    return data || res.data
  },
  function (error) {
    const response = error.response
    if (response && response.status === 401) {
      store.dispatch('user/setUserInfo', null)
      return Promise.reject(new Error('登陆失效'))
    }

    return Promise.reject(error)
  })

export default {
  get ({ url, data = {} }) {
    return axios({
      method: 'get',
      url: BASE_URL + url,
      params: data,
      headers: {
        Authorization: localStorage.getItem('token') || '',
      },
    })
  },

  post ({ url, data = {} }) {
    return axios({
      method: 'post',
      url: BASE_URL + url,
      data: data,
      transformRequest: [function (val) {
        let ret = ''
        for (let key in val) {
          if (val.hasOwnProperty(key)) {
            ret += encodeURIComponent(key) + '=' + encodeURIComponent(val[key]) + '&'
          }
        }
        return ret.slice(0, -1)
      }],
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: localStorage.getItem('token') || '',
      },
    })
  },

  postJSON ({ url, data = {} }) {
    return axios({
      method: 'post',
      url: BASE_URL + url,
      data: data,
      headers: {
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('token') || '',
      },
    })
  },

}
